var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#c8c8c8",
    viewBox: "0 0 122.88 100.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video-edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.72,0h89.63a11.73,11.73,0,0,1,11.72,11.72V40a15.63,15.63,0,0,0-4.53-.1c-.37,0-.74.09-1.11.16V26.31H5.65V73.16h65.9a14.91,14.91,0,0,0-2.17,5.64H60.13V94.47h7.11l-.11.82a15.12,15.12,0,0,0,.13,4.83H11.72A11.74,11.74,0,0,1,0,88.4V11.72A11.74,11.74,0,0,1,11.72,0ZM97.2,94.26l-15,3,2.17-16L97.2,94.26ZM89.1,76.5l20.22-21a1.38,1.38,0,0,1,1.73-.27l11.47,11.1a1.22,1.22,0,0,1-.1,1.82L101.93,89.43,89.1,76.5ZM50.5,33.65,70.33,47.47a3,3,0,0,1,.81.79,2.81,2.81,0,0,1-.72,3.92L50.68,65.83a2.83,2.83,0,0,1-4.62-2.19V36s.43-1.49.51-1.62a2.83,2.83,0,0,1,3.93-.69Zm4,60.82V78.8H31.71V94.47ZM26.06,78.8H5.65v9.6a6.09,6.09,0,0,0,6.07,6.07H26.06V78.8ZM82.28,20.66v-15H60.13v15Zm5.65-15v15h19.49V11.72a6.09,6.09,0,0,0-6.08-6.07Zm-33.45,15v-15H31.71v15Zm-28.42,0v-15H11.72a6.09,6.09,0,0,0-6.07,6.07v8.94Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEdit);
export default __webpack_public_path__ + "static/media/video-edit.ae31718558d251f915c3ae3f4a74f7ba.svg";
export { ForwardRef as ReactComponent };